import { Check } from "lucide-react";
import { STEP_LABELS } from "./quoteConfig";

export const StepIndicator = ({ current }) => (
  <ol className="flex items-center gap-2 sm:gap-3" aria-label="Quote form progress" data-testid="quote-step-indicator">
    {STEP_LABELS.map((label, i) => {
      const done = i < current;
      const active = i === current;
      return (
        <li key={label} className="flex items-center gap-2 sm:gap-3 flex-1 last:flex-none">
          <div className="flex items-center gap-2.5" aria-current={active ? "step" : undefined}>
            <span
              className={`grid h-8 w-8 shrink-0 place-items-center rounded-full border font-mono text-xs transition-[background-color,border-color,color] duration-500 ${
                done ? "border-transparent bg-gradient-to-br from-indigo-500 to-violet-500 text-white" : active ? "border-violet-400 text-white bg-violet-500/15 shadow-[0_0_20px_-4px_rgba(139,92,246,0.9)]" : "border-white/10 text-slate-500"
              }`}
            >
              {done ? <Check className="h-3.5 w-3.5" aria-hidden="true" /> : i + 1}
            </span>
            <span className={`hidden xl:block text-xs font-medium whitespace-nowrap ${active ? "text-white" : done ? "text-slate-300" : "text-slate-600"}`}>{label}</span>
          </div>
          {i < STEP_LABELS.length - 1 && <span className={`h-px flex-1 transition-colors duration-500 ${done ? "bg-violet-400/60" : "bg-white/10"}`} aria-hidden="true" />}
        </li>
      );
    })}
  </ol>
);
